import { Link as LinkMagik, Pagination, createTable } from "@inmagik/magik-ui"
import { Facsimile, FiltersBase } from "../../types"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Facsimile>()

export function TableFacsimili({
  facsimili,
  setFilters,
  filters,
  count,
  fullCount,
  showEdizione = true,
  actionLink,
}: {
  facsimili: Facsimile[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  showEdizione?: boolean
  actionLink?: (v?: Facsimile) => void
}) {
  const numPages = useMemo(() => {
    if (!facsimili) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [facsimili, count])

  return (
    <Table
      data={facsimili}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Titolo"
        name="titolo"
        sortable
        width="minmax(max-content, 1fr)"
        render={(facsimile) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(facsimile)} style={{ cursor: "pointer" }}>
              {facsimile.titolo}
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/facsimili/${facsimile.id}/`}>
              <LinkMagik className="text-dark">{facsimile.titolo}</LinkMagik>
            </Link>
          )
        }
      />
      {showEdizione && (
        <Table.Column
          title="Edizione"
          name="titolo_completo_edizione"
          sortable
          width="minmax(max-content, 1fr)"
          render={(facsimile) => (
            <div>
              {facsimile.edizione_data.opera_data.titolo} - {facsimile.titolo_completo_edizione}
            </div>
          )}
        />
      )}

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} facsimili
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
